import { render, staticRenderFns } from "./CcKeywordsReviewTable.vue?vue&type=template&id=64f6f701&"
import script from "./CcKeywordsReviewTable.vue?vue&type=script&lang=js&"
export * from "./CcKeywordsReviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports